import React from 'react';
import { Alert, Snackbar } from '@mui/material';

const palette = {
  success: { backgroundColor: '#16a34a', color: '#ffffff' },
  error: { backgroundColor: '#dc2626', color: '#ffffff' },
  warning: { backgroundColor: '#f59e0b', color: '#111827' },
  info: { backgroundColor: '#0284c7', color: '#ffffff' },
};

function NotificationSnackbar({ open, message, severity = 'info', onClose }) {
  const tone = palette[severity] || palette.info;
  return (
    <Snackbar
      open={open}
      autoHideDuration={4500}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      sx={{
        '& .MuiPaper-root': {
          minWidth: { xs: 'calc(100vw - 28px)', sm: 520 },
          maxWidth: { xs: 'calc(100vw - 28px)', sm: 720 },
        },
      }}
    >
      <Alert
        onClose={onClose}
        severity={severity}
        variant="filled"
        sx={{
          ...tone,
          width: '100%',
          px: 2,
          py: 1.15,
          borderRadius: 2,
          boxShadow: '0 12px 32px rgba(15, 23, 42, .28)',
          fontSize: 14,
          fontWeight: 700,
          alignItems: 'center',
          '& .MuiAlert-icon': { color: 'inherit', opacity: 1 },
          '& .MuiAlert-action': { color: 'inherit' },
        }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
}

export default NotificationSnackbar;
